import React, { Component } from 'react';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import { connect } from 'react-redux';
import { signOut } from 'actions/auth/userToken';
import { Link } from 'react-router-dom';
import { openCustomModal } from 'actions/modals';
import classnames from 'classnames';
import ImageThumbnail from 'components/util/imageThumbnail';
import styles from './styles.scss';
import logo from 'assets/images/logo.png';
import { pushStrings } from 'actions/api/config';
import { openConfirmModal, openAlertModal } from 'actions/modals';
import Survey from 'components/navbar/survey';

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileDropdownOpen: false,
      stringsPushing: false
    };
  }

  handleClick = event => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      profileDropdownOpen: true,
      anchorEl: event.currentTarget
    });
  };

  handleRequestClose = () => {
    this.setState({
      profileDropdownOpen: false
    });
  };

  signOut = () => {
    signOut();
    window.location.reload();
  };

  gotoApp = () => {
    window.location.href = 'http://app.lodplanner.com';
  };

  openProfileModal = () => {
    this.props.openCustomModal({
      component: 'modal here', // TODO
      title: 'Edit Profile',
      initialValues: this.props.currentUser
    });
    this.setState({
      profileDropdownOpen: false
    });
  };

  pushStrings = () => {
    this.props.dispatch(
      openConfirmModal({
        text:
          'Are you sure you want to push these strings? You will be unable to change string keys or delete strings that have been pushed.',
        onConfirm: async () => {
          this.setState({ stringsPushing: true });
          let data;
          try {
            const res = await pushStrings();
            data = res.data;
            this.props.dispatch(
              openAlertModal({
                title: 'Hurray!',
                text:
                  'Strings have been pushed. See console to see what was pushed.'
              })
            );
            console.log(data);
          } catch (e) {
            this.props.dispatch(
              openAlertModal({
                title: 'Uh oh...',
                text: 'Something went wrong with the string push.'
              })
            );
          }
          this.setState({ stringsPushing: false });
        }
      })
    );
  };

  render() {
    const { currentUser } = this.props;

    return (
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.inner}>
            <div className={styles.navLeft}>
              <Link to={'/'}>
                <img src={logo} className={styles.logo} alt="logo" />
              </Link>
              {currentUser && currentUser.user_type_enum === 1 && (
                <div className={styles.menuItems}>
                  <Link
                    to={'/add-strings'}
                    className={classnames(styles.menuItem, {
                      [styles.active]: window.location.href.includes(
                        'add-strings'
                      )
                    })}>
                    Add Strings
                  </Link>
                  <Link
                    to={'/manage-translations'}
                    className={classnames(styles.menuItem, {
                      [styles.active]: window.location.href.includes(
                        'manage-translations'
                      )
                    })}>
                    Manage Translations
                  </Link>
                  <Link
                    to={'/manage-users'}
                    className={classnames(styles.menuItem, {
                      [styles.active]: window.location.href.includes(
                        'manage-users'
                      )
                    })}>
                    Manage Users
                  </Link>
                  <Link
                    to={'/manage-languages'}
                    className={classnames(styles.menuItem, {
                      [styles.active]: window.location.href.includes(
                        'manage-languages'
                      )
                    })}>
                    Manage Languages
                  </Link>
                </div>
              )}
            </div>
            {currentUser && currentUser.user_type_enum === 2 && <Survey />}
            <div className={styles.navRight}>
              <a
                onClick={this.handleClick}
                className={classnames([
                  { [styles.active]: this.state.profileDropdownOpen }
                ])}>
                {/* just in case user happens to be refreshing after token expired */}
                {this.props.currentUser && (
                  <span>
                    <ImageThumbnail
                      imgUrl={this.props.currentUser.profile_img}
                      size="lg"
                      userAvatar
                    />
                    {this.props.currentUser.first_name}
                  </span>
                )}
                <span className={styles.caret} />
              </a>
              <Popover
                open={this.state.profileDropdownOpen}
                anchorEl={this.state.anchorEl}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                onRequestClose={this.handleRequestClose}>
                <Menu>
                  <MenuItem
                    primaryText="Plannerly App"
                    onClick={this.gotoApp}
                  />
                  {currentUser &&
                    currentUser.user_type_enum === 1 &&
                    currentUser.is_activated && (
                      <MenuItem
                        disabled={this.state.stringsPushing}
                        onClick={this.pushStrings}>
                        {this.state.stringsPushing
                          ? 'Pushing strings...'
                          : 'Push Strings'}
                      </MenuItem>
                    )}
                  <MenuItem primaryText="Sign out" onClick={this.signOut} />
                </Menu>
              </Popover>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { currentUserId } = state.sessionSettings;
  return {
    currentUser: state.users.map[currentUserId],
    isAuthenticated: !!state.sessionSettings.currentUserId
  };
}

export default connect(
  mapStateToProps,
  { openCustomModal }
)(Navbar);



// WEBPACK FOOTER //
// ./src/components/navbar/index.js